import { type FC } from 'react';
import dayjs from 'dayjs';
import { UiHStack, UiStack, uiStyles, UiText } from '@/lib/ui';
import { type Registration } from '@/api/registration';
import BaseBlockList from '@/base/BlockList';

interface RegistrationTypeProps {
  registration: Registration
}

const RegistrationType: FC<RegistrationTypeProps> = ({ registration }) => {
  return (
    <UiStack spacing={4}>
      <UiHStack justifyContent={'space-between'}>
        <UiText fontWeight={'bold'}>
          Registration type
        </UiText>
      </UiHStack>
      <BaseBlockList
        bgColor={'#fff'}
        borderRadius={uiStyles.borderRadius}
        enableDivider={true}
        shadow={'none'}
        borderColor={'gray.300'}
        borderWidth={'1px'}
        borderStyle={'solid'}
      >
        <UiStack spacing={1} px={8} py={4}>
          <UiText variant={'body1'}>{registration.mainEventTicket}</UiText>
        </UiStack>
      </BaseBlockList>
    </UiStack>
  );
};

export default RegistrationType;
